import Axios, { AxiosInstance } from 'axios'

const axios: AxiosInstance = Axios.create({
  baseURL: '/api/v1/',
})
axios.interceptors.response.use(
  response => {
    return response
  },
  err => {
    if (err.response && err.response.status === 401) {
      window.location.href = '/#/login'
    }
    return Promise.reject(err)
  },
)

// Request helpers ($get, $post, ...)
for (const method of ['request', 'delete', 'get', 'head', 'options', 'post', 'put', 'patch']) {
  axios['$' + method] = function() {
    // eslint-disable-next-line
    return this[method].apply(this, arguments).then(res => res && res.data)
  }
}

export default axios
